module.exports = __webpack_public_path__ + "img/supermicro.31481693.svg";